var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _circle, _circle2, _circle3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 140,
    viewBox: "0 0 303 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.031 55.7812H302.969",
    stroke: "#E62E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.5 51.4062V61.25",
    stroke: "#E62E2E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.656 98.4375C211.251 93.8211 214.987 84.1182 217.656 79.8438H154.219V98.4375H217.656Z",
    fill: "#FFECEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.209 24.0625C182.676 18.8125 180.597 15.3125 179.375 14.2188H200.156C197.711 18.9437 199.138 22.75 200.156 24.0625H181.209Z",
    fill: "#FFECEC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.25,
    width: 55.7812,
    height: 14.2188,
    rx: 6.5,
    fill: "#FFECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 226.406,
    y: 4.375,
    width: 20.7812,
    height: 14.2188,
    rx: 6.5,
    fill: "#FFECEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 281.094,
    y: 72.1875,
    width: 19.6875,
    height: 10.9375,
    rx: 5.46875,
    fill: "#FFECEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 169.531,
    y: 24.0625,
    width: 72.1875,
    height: 15.3125,
    rx: 7,
    fill: "#FFECEC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.3125,
    y: 65.625,
    width: 183.75,
    height: 14.2188,
    rx: 6.5,
    fill: "#FFECEC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8125,
    y: 98.4375,
    width: 216.562,
    height: 14.2188,
    rx: 6.5,
    fill: "#FFECEC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 125.781,
    width: 166.25,
    height: 14.2188,
    rx: 6.5,
    fill: "#FFECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 125.781C61.4291 121.056 57.4965 115.062 54.6875 112.656H144.375V125.781H54.6875Z",
    fill: "#FFECEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.188,
    cy: 22.9688,
    r: 6.65625,
    stroke: "#E62E2E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.594,
    cy: 129.062,
    r: 5.5625,
    stroke: "#E62E2E",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.031,
    cy: 91.875,
    r: 46.125,
    fill: "#FFECEC",
    stroke: "#E62E2E",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58361_7293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.084 77.5595L166.441 73.917L152 88.3578L137.559 73.917L133.917 77.5595L148.358 92.0003L133.917 106.441L137.559 110.084L152 95.6428L166.441 110.084L170.084 106.441L155.643 92.0003L170.084 77.5595Z",
    fill: "#E62E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58361_7293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(121 61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.3d212f3706c76cc06cd43f99b267b916.svg";
export { ForwardRef as ReactComponent };